// Organization Status Options
export const ORGANIZATION_STATUS_OPTIONS = [
  { label: 'Active', value: 'ACTIVE' },
  { label: 'Inactive', value: 'INACTIVE' },
  { label: 'Deleted', value: 'DELETED' },
];

// Filter options for table
export const ORGANIZATION_STATUS_FILTER_OPTIONS = ORGANIZATION_STATUS_OPTIONS;